(function () {
  'use strict';

  angular
    .module('directive.searchlink', [])

    /* @ngInject */
    .directive('searchLink', ["HttpService", function (HttpService) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          element.click(function (event) {
            HttpService.post({
              url: 'Search/SearchLog',
              data: {
                Query: attrs.query,
                Id: attrs.id,
                Index: attrs.index,
                Type: attrs.type
              }
            });
          });
          scope.$on('$destroy', function () {
            element.off('click');
          });
        }
      };
    }]);
})();
